module.exports = __webpack_public_path__ + "static/img/015.ab3067f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/015.png
// module id = NLBr
// module chunks = 1